import * as React from 'react';
import * as _ from 'lodash';
import { Link } from 'react-router';
import { Element } from 'react-scroll';
import moment from 'moment';
import BlogPostSocial from './BlogPostSocial/_lazy';
export default function () {
    return React.createElement('div', { 'className': 'BlogPost' }, React.createElement(Element, { 'name': this.props.elementName }, React.createElement('div', { 'className': 'overlay' }, React.createElement(Link, {
        'aria-label': 'Read "' + this.props.title + '"',
        'to': '/blog/' + this.props.slug
    })), React.createElement('div', { 'className': 'photo' }, React.createElement('img', {
        'src': this.props.photo.medium,
        'alt': this.props.title,
        'role': 'presentation'
    })), React.createElement('div', { 'className': 'info-wrapper' }, this.props.category ? React.createElement(Link, {
        'to': `/blog/?category=${ this.props.category.slug }`,
        'className': 'category',
        'key': '578'
    }, this.props.category.name) : null, React.createElement('h3', { 'className': 'title' }, this.props.title), React.createElement('p', { 'className': 'description' }, this.props.description), React.createElement('div', { 'className': 'extra-info' }, this.props.showSocial ? React.createElement('div', {
        'className': 'social-networks',
        'key': '900'
    }, React.createElement(BlogPostSocial, {
        'socialUrl': this.props.socialUrl,
        'title': this.props.title
    })) : null, React.createElement('div', { 'className': 'line' }), React.createElement('div', { 'className': 'created' }, '\n            ', moment(this.props.orderDate ? this.props.orderDate : this.props.created).format(MONTH_DAY_YEAR_FORMAT), '\n          ')))));
}